import { all, put, select } from 'redux-saga/effects';

import * as CarInstanceActions from 'store/carInstance/actions';
import * as CarInstanceConstants from 'store/carInstance/constants';
import * as CarInstanceHelpers from 'store/carInstance/helper';
import * as CarInstanceSelectors from 'store/carInstance/selectors';
import * as CarReferenceActions from 'store/carReference';
import * as CarReferenceConstants from 'store/carReference/constants';
import * as CarReferenceSelectors from 'store/carReference/selectors';
import { selectWhen } from 'store/helpers';

import * as InsuranceConstants from '../../constants';
import { CreateStage } from '../../helpers';

export const insuranceStageSelectVersion = new CreateStage({
  action: InsuranceConstants.ACTIONS.SELECT_VERSION,
  handler: function* () {
    yield all([
      // Ждем когда car instance заполнится
      selectWhen(CarInstanceSelectors.selectFetch, false),
      // Ждем когда загрузится список комплектаций
      selectWhen(CarReferenceSelectors.selectVersionsFetch, false),
    ]);

    const isNew = yield select(
      CarInstanceSelectors.selectValuesField(CarInstanceConstants.VALUE_FIELDS.IS_NEW)
    );

    if (!isNew) {
      return;
    }

    const version = yield selectWhen(
      CarInstanceSelectors.selectValuesField(CarInstanceConstants.VALUE_FIELDS.VERSION)
    );
    const versions = yield select(CarReferenceSelectors.selectVersions);

    if (!version || !Array.isArray(versions)) {
      return;
    }

    const foundVersion = CarInstanceHelpers.findVersion({ version, versions });

    // Выбираем комплектацию, устраивает и undefined
    yield put(
      CarReferenceActions.setSelected({
        [CarReferenceConstants.SELECTED_FIELDS.VERSION]: foundVersion,
      })
    );

    if (typeof foundVersion !== 'undefined') {
      return;
    }

    // Сбрасываем состояния если неизвестная комплектация
    yield put(
      CarInstanceActions.setCarInstance({
        [CarInstanceConstants.VALUE_FIELDS.YEAR]: undefined,
        [CarInstanceConstants.VALUE_FIELDS.VERSION]: undefined,
      })
    );
  },
  name: InsuranceConstants.STAGES_FIELDS.SELECT_VERSION,
}).watcher;
